import { render, staticRenderFns } from "./ReviewsDashboard.vue?vue&type=template&id=57620c7d&scoped=true&"
import script from "./ReviewsDashboard.vue?vue&type=script&lang=js&"
export * from "./ReviewsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsDashboard.vue?vue&type=style&index=0&id=57620c7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57620c7d",
  null
  
)

export default component.exports